import {
  ADD_PRODUCT_COUNT,
  ADD_TO_CART,
  LOAD_CART,
  LOAD_PRODUCTS,
  REMOVE_FROM_CART,
  REMOVE_PRODUCT_COUNT,
} from "./types";

const generateTotal = cart => {
  const totalCost = cart.reduce((total, currProduct) => +total + +currProduct.productTotal, 0.0);
  const totalWithTax = totalCost + 10;
  return {
    totalCost: totalCost.toFixed(2),
    totalWithTax: totalWithTax.toFixed(2),
  };
};

const getProduct = (product, value) => {
  const quantity = value > 0 ? value : 0;
  return {
    ...product,
    price: +product.price.toFixed(2),
    quantity,
    productTotal: (+product.price * +quantity).toFixed(2),
  };
};

export const favouriteReducer = (state, action) => {
  let updatedCart;

  switch (action.type) {
    case LOAD_PRODUCTS:
      return {
        ...state,
        products: action.payload.map(product => getProduct(product, 0)),
      };

    //load cart {cart is seperate from entire products list }
    case LOAD_CART:
      updatedCart = state.products.map(product => getProduct(product, 1));

      return {
        ...state,
        cartProducts: updatedCart,
        totalItems: updatedCart.length,
        totalCost: generateTotal(updatedCart).totalCost,
        totalCostAfterTax: generateTotal(updatedCart).totalWithTax,
      };

    case ADD_TO_CART:
      const addedProduct = state.products.find(product => product.id === action.payload);

      if (!addedProduct) {
        return state;
      }

      updatedCart = [...state.cartProducts, getProduct(addedProduct, 1)];

      return {
        ...state,
        cartProducts: updatedCart,
        totalItems: updatedCart + 1,
        totalCost: generateTotal(updatedCart).totalCost,
        totalCostAfterTax: generateTotal(updatedCart).totalWithTax,
      };

    case REMOVE_FROM_CART:
      updatedCart = state.cartProducts.filter(product => product.id !== action.payload);

      return {
        ...state,
        cartProducts: updatedCart,
        totalItems: updatedCart - 1,
        totalCost: generateTotal(updatedCart).totalCost,
        totalCostAfterTax: generateTotal(updatedCart).totalWithTax,
      };

    case ADD_PRODUCT_COUNT:
      updatedCart = state.cartProducts.map(product =>
        product.id === action.payload ? getProduct(product, product.quantity + 1) : product
      );
      return {
        ...state,
        cartProducts: updatedCart,
        totalCost: generateTotal(updatedCart).totalCost,
        totalCostAfterTax: generateTotal(updatedCart).totalWithTax,
      };

    case REMOVE_PRODUCT_COUNT:
      updatedCart = state.cartProducts.map(product =>
        product.id === action.payload ? getProduct(product, product.quantity - 1) : product
      );
      return {
        ...state,
        cartProducts: updatedCart,
        totalCost: generateTotal(updatedCart).totalCost,
        totalCostAfterTax: generateTotal(updatedCart).totalWithTax,
      };
    default:
      return state;
  }
};
